import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/community", label: "Community" },
  { to: "/brands", label: "Brands" },
  { to: "/music", label: "Music" },
  { to: "/creator", label: "Grow As A Creator" },
  { to: "/about", label: "My Story" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar({ revealed = true }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="main-navbar"
      className={`site-chrome fixed top-0 z-50 w-full border-b border-white/5 bg-black/60 backdrop-blur-xl ${revealed ? "" : "site-chrome-hidden"}`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Link to="/" data-testid="nav-logo" className="font-display text-lg font-bold tracking-[0.2em]">
          <span className="gold-text">AVINASH KUMAR</span>
        </Link>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`nav-underline text-[13px] font-medium tracking-wide text-white/85 transition-colors duration-300 hover:text-white ${
                location.pathname === l.to ? "active text-white" : ""
              }`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="mobile-menu-button" aria-label="Open menu" className="p-2 text-white/90">
                <Menu size={22} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72 border-white/10 bg-[#0c0c0c]">
              <div className="mt-10 flex flex-col gap-6">
                {LINKS.map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => setOpen(false)}
                    className="font-display text-xl text-white/90 transition-colors duration-300 select-none hover:text-crimson"
                  >
                    {l.label}
                  </Link>
                ))}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
